import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import scrollbars from '@helpers/scrollbars';
import styled from 'styled-components';
const Results = styled.div `
  --resultsMaxHeight: 246px;

  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 100%;
  background-color: ${brand.global.white};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
`;
const List = styled.ul `
  max-height: var(--resultsMaxHeight);
  overflow-y: auto;
  ${scrollbars}
`;
const Item = styled.li `
  color: ${brand.primary.base};
  display: block;
  width: 100%;
  font-size: 14px;
  padding: 12px 16px;

  em {
    ${fonts.openSans.extraBold}
  }

  small {
    font-size: 12px;
    color: ${brand.primary.purple.base};
  }
`;
const Link = styled.a `
  color: ${brand.primary.base};
  font-size: 14px;
  text-decoration: none;

  &:hover,
  &:focus-visible {
    background-color: ${brand.tertiary.nearlyWhite.light};
  }
`;
const Loader = styled.div `
  display: flex;
  justify-content: center;
  padding: 12px 16px;
`;
export default {
    Results,
    List,
    Item,
    Link,
    Loader,
};
